import React, { useEffect, useState } from "react";
import Button from "../components/ui/Button";
import InputField from "../components/form/elements/InputField";
import auth from "../services/authServices";
import http from "../services/httpServices";
import modal from "../services/modalServices";
import InputIcon from "../components/form/elements/InputIcon";
import { handleInputChange as handleChange } from "../services/formServices";
import inputDateIcon from "../assets/Updated-imagery/input_Date.png";
import MeetingIcon from "../assets/Updated-imagery/meeting_icon.png";
import { printFullDateTimeInHours } from "../utils/time";
import LoadingIcon from "../components/ui/LoadingIcon";
import CenterIcon from "../components/ui/CenterIcon";
import { useLanguage } from "../context/LanguageContext";

const SessionReservationForm = ({ afterSuccess = () => null, userAvailableSessionsCount = 0 }) => {
    const { language } = useLanguage();
    const content = {
        heading: {
            en: "After selecting a day, the available sessions will appear.",
            ar: "بعد ما تختار اليوم المراد حجزه هتظهر ليك المواعيد المتاحة",
        },
        modalTitle: {
            en: "Your reservation is confirmed",
            ar: "تم حجز مكانك",
        },
        modalText: {
            en: "Your session has been reserved for the selected time. Please wait.",
            ar: "تم حجز الموعد الخاص بيك في المعاد المحدد برجاء الإنتظار",
        },
        placeholder: {
            en: "Choose a suitable date",
            ar: "أختر التاريخ المناسب ليك",
        },
        noCredit: {
            en: "Unfortunately, you've run out of live session credits.",
            ar: "للأسف انت خلصت رصيدك من حجز الجلسات المباشره",
        },
        reserveSession: {
            en: "Reserve a session time",
            ar: "أحجزلي معاد الجلسة",
        },
        noDateSelected: {
            en: "Choose a suitable date to view available sessions.",
            ar: "أختار اليوم المناسب عشان تشوف المواعيد المُتاحة",
        },
        loadingMessage: {
            en: "Loading available sessions for the selected date...",
            ar: "يتم الآن تحميل المواعيد المتاحة لليوم المختار",
        },
        chooseSession: {
            en: "Hurry! Choose a suitable time for your session.",
            ar: "الحق أختار الميعاد المناسب ليك",
        },
        noSessionsAvailable: {
            en: "No available sessions for this date. Try selecting another date.",
            ar: "مفيش مواعيد مُتاحة لليوم ده للأسف .. أختار يوم تاني مناسب ليك ومتيأسش",
        },
        card: {
            sessionTime: {
                en: "Session Time",
                ar: "معاد الجلسة",
            },
            sessionTitle: {
                en: "Session Title:",
                ar: "عنوان الجلسة المباشره",
            },
            assistantTeacher: {
                en: "Assistant Teacher:",
                ar: "المدرس المٌساعد:",
            },
            note: {
                en: "Note:",
                ar: "ملحوظة:",
            },
            remainingSeats: {
                en: "Remaining Seats:",
                ar: "الأماكن المتبقية:",
            },
            noSeatsAvailable: {
                en: "Unfortunately, no seats are available.",
                ar: "للأسف لا يوجد أماكن متبقية",
            },
            seatsRemaining: {
                en: "seats remaining",
                ar: "مكان متبقي",
            },
        },
    };
    const [data, setData] = useState({
        choosen_reservation_date: "",
        selected_session_id: "",
    });
    const [selectedSession, setSelectedSession] = useState(null);
    const [availableSessions, setAvailableSessions] = useState([]);
    const [isFetchLoading, setIsFetchLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const isSessionExpired = (session) => {
        const sessionStartTime = new Date(session.session_date);
        const sessionEndTime = new Date(
            sessionStartTime.getTime() + (session.duration_in_minutes + 15) * 60000
        );
        return new Date() > sessionEndTime;
    };

    const handleReservation = async () => {
        setIsLoading(true);
        const token = auth.getToken();
        const config = auth.getAuthConfig(token);
        try {
            const { data: response } = await http.post(
                `/api/live_sessions/${selectedSession}/request_attendance`,
                { ...data },
                config
            );
            modal.message({
                title: content.modalTitle[language],
                text: content.modalText[language],
                callback: () => {
                    setData([]);
                    afterSuccess();
                },
            });
            setIsLoading(false);
        } catch ({ response }) {
            setIsLoading(false);
            // if (response.status != 422) {
            //     modal.message({
            //         title: "حدث خطأ",
            //         text: "يرجى الاتصال بالدعم",
            //         icon: "error",
            //     });
            // }
            // setIsDisabled(false);
        }
    };

    const handleSessionClick = (sessionId) => {
        if (selectedSession === sessionId) {
            setSelectedSession(null);
            return;
        }
        setSelectedSession(sessionId);
    };

    const fetchAvailableSessions = async (chosenDate) => {
        setIsFetchLoading(true);
        try {
            const token = auth.getToken();
            const config = auth.getAuthConfig(token);
            const { data: response } = await http.get(
                `/api/live_sessions/available_sessions?session_day=${chosenDate}`,
                config
            );

            setAvailableSessions(response.available_sessions);
            setIsFetchLoading(false);
        } catch (error) {
            setIsFetchLoading(false);
            // setError(" حدث خطأ أثناء جلب المواعيد المتاحة");
        }
    };

    useEffect(() => {
        if (data.choosen_reservation_date) {
            fetchAvailableSessions(data.choosen_reservation_date);
        }
    }, [data.choosen_reservation_date]);

    return (
        <div className=" flex flex-col space-y-2">
            <div className="flex flex-center-both">
                <div className="flex flex-col space-y-20 w-full">
                    <div>
                        <div className="pb-5 text-center space-y-3">
                            <div className="font-h1">{content.heading[language]} </div>
                        </div>
                        <div className="flex-center-both flex-col">
                            <div className="flex flex-row items-end space-x-2 space-x-reverse  pb-4 pt-2 w-full">
                                <div className="w-full bg-slate-200 dark:bg-slate-900 smooth clr-text-primary border border-black p-5 ">
                                    <InputField
                                        id="choosen_reservation_date"
                                        className="w-full"
                                        placeholder={content.placeholder[language]}
                                        icon={
                                            <span className="flex-center-both mb-1">
                                                <InputIcon icon="icon-park-solid:edit-name" />
                                            </span>
                                        }
                                        data={data}
                                        setData={setData}
                                        onChange={handleChange}
                                        type="datepicker"
                                        datePickerPerWeek
                                        isDisabled={userAvailableSessionsCount > 0 ? false : true}
                                    />
                                    {userAvailableSessionsCount > 0 ? (
                                        ""
                                    ) : (
                                        <div className="text-center pt-5">
                                            {content.noCredit[language]}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    {!data.choosen_reservation_date ? (
                        <div className="w-full flex-center-both  flex-col space-y-5  bg-ashGray-100 border border-black rounded-3xl py-5 px-20 dark:bg-ashGray-100 smooth clr-text-primary">
                            <img src={inputDateIcon} alt="inputDateIcon" className="w-20 h-auto" />
                            <span className="w-full font-h2 text-center">
                                {content.noDateSelected[language]}
                            </span>
                        </div>
                    ) : isFetchLoading ? (
                        <div className="flex-center-both flex-row space-x-3 space-x-reverse bg-third-container clr-text-primary border border-secondary-container smooth py-5 px-5 rounded-md">
                            <div className="font-w-bold font-h1 text-sky-500">
                                <LoadingIcon />
                            </div>
                            <div className="font-w-bold font-h3">
                                {content.loadingMessage[language]}
                            </div>
                        </div>
                    ) : availableSessions.length && availableSessions.length > 0 ? (
                        <div className="flex space-y-10 flex-col items-end pb-4 pt-2 w-full">
                            <h1 className="flex-center-both w-full flex-col space-y-5">
                                <img
                                    src={inputDateIcon}
                                    alt="inputDateIcon"
                                    className="w-[56px] h-auto"
                                />
                                <span className="font-h2">{content.chooseSession[language]}</span>
                            </h1>
                            <div className="w-full flex-center-both flex-col space-y-10 p-5">
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full gap-4 ">
                                    {availableSessions.map((session) => (
                                        <button
                                            disabled={
                                                session.maximum_attendance <=
                                                session.live_session_user_attendances_count
                                            }
                                            key={session.id}
                                            className={`relative p-3 flex flex-col space-y-4  rounded-md  w-[300px] border-2 ${
                                                session.maximum_attendance <=
                                                session.live_session_user_attendances_count
                                                    ? "cursor-not-allowed opacity-50 border-secondary-container smooth"
                                                    : selectedSession === session.id
                                                    ? "border-slate-400 bg-slate-300 dark:bg-slate-200 smooth"
                                                    : "border-ashGray-100/25 bg-ashGray-50 smooth hover:bg-ashGray-100 "
                                            } focus:outline-none `}
                                            onClick={() => handleSessionClick(session.id)}
                                        >
                                            <h3 className="font-bold clr-text-primary smooth text-center w-full text-lg mb-2 flex-center-both flex-col">
                                                <div className="text-ashGray-700 dark:text-ashGray-800 smooth font-w-bold">
                                                    {content.card.sessionTime[language]}
                                                </div>{" "}
                                                <div className="font-w-bold bg-earthYellow-500 text-white px-2 rounded-md">
                                                    {printFullDateTimeInHours(
                                                        session.session_date,
                                                        language
                                                    )}
                                                </div>
                                            </h3>
                                            {/* {session.maximum_attendance ==
                                            session.live_session_user_attendances_count ? (
                                                <div className="flex-center-both w-full">
                                                    <div className="bg-rose-500 text-white px-2 rounded-md pb-1">
                                                        تم امتلاء العدد المسموح
                                                        <br />
                                                        به لهذا المعاد
                                                    </div>
                                                </div>
                                            ) : (
                                                ""
                                            )} */}

                                            <p className="text-sm text-gray-700 dark:text-gray-300 smooth">
                                                <strong className="text-ashGray-500 dark:text-ashGray-800 smooth">
                                                    {content.card.sessionTitle[language]}
                                                </strong>{" "}
                                                {session.name}
                                            </p>
                                            <p className="text-sm text-gray-700 dark:text-gray-300 smooth">
                                                <strong className="text-ashGray-500 dark:text-ashGray-800 smooth">
                                                    {content.card.assistantTeacher[language]}
                                                </strong>{" "}
                                                {session.admin?.full_name}
                                            </p>
                                            <p className="text-sm text-gray-700 dark:text-gray-300 smooth">
                                                <strong className="text-ashGray-500 dark:text-ashGray-800 smooth">
                                                    {content.card.note[language]}
                                                </strong>{" "}
                                                {session.description}
                                            </p>
                                            <p className="text-sm flex-center-both gap-2 text-gray-700 dark:text-gray-300 smooth">
                                                <strong className="text-ashGray-500 dark:text-ashGray-800 smooth">
                                                    {content.card.remainingSeats[language]}
                                                </strong>{" "}
                                                {session.maximum_attendance <=
                                                session.live_session_user_attendances_count ? (
                                                    <p className="bg-rose-600 clr-white py-1 px-3 rounded-md">
                                                        {content.card.noSeatsAvailable[language]}
                                                    </p>
                                                ) : (
                                                    <p className="bg-yellow-500 text-black rounded-md py-1 px-3">
                                                        {session.maximum_attendance -
                                                            session.live_session_user_attendances_count}{" "}
                                                        {content.card.seatsRemaining[language]}{" "}
                                                    </p>
                                                )}
                                            </p>
                                            <div
                                                className={`absolute top-2 right-2 !m-0 font-h1 text-yellow-500 ${
                                                    selectedSession === session.id
                                                        ? "opacity-100"
                                                        : "opacity-0"
                                                }`}
                                            >
                                                <CenterIcon icon="icon-park-twotone:check-one" />
                                            </div>
                                            {/* <a
                                                href={session.session_url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="bg-ashGray-500 smooth rounded-xl mx-auto dark:bg-secYellow-800 text-xl text-black py-2 px-4"
                                            >
                                                لينك الجلسة
                                            </a> */}
                                        </button>
                                    ))}
                                </div>
                                {/* Reserve button */}
                                <Button
                                    color="ashGray"
                                    className={`text-xl text-center font-bold  text-black px-[20px]  py-[10px] border-none inline-block smooth shadow-md hover:shadow-lg rounded-xl w-3/4 ${
                                        !selectedSession && "opacity-40 cursor-not-allowed"
                                    } `}
                                    isLoading={isLoading}
                                    isDisabled={
                                        !selectedSession ||
                                        isSessionExpired(
                                            availableSessions.find((s) => s.id === selectedSession)
                                        )
                                    }
                                    onClick={() => handleReservation()}
                                >
                                    {content.reserveSession[language]}{" "}
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <div className="w-full flex-center-both  flex-col space-y-5  bg-rose-300 border border-black rounded-3xl py-5 px-20 dark:bg-rose-900 smooth ">
                            <img src={MeetingIcon} alt="inputDateIcon" className="w-20 h-auto" />
                            <span className="w-3/4 font-h2 text-center">
                                {content.noSessionsAvailable[language]}
                            </span>
                        </div>
                    )}

                    {/* {availableSessions.length < 1 && data.choosen_reservation_date && (
                        
                    )} */}
                </div>
            </div>
        </div>
    );
};

export default SessionReservationForm;
